import { SeededRandom } from '../../services/RandomSource';

export type StarLayerId = 'dust' | 'distant' | 'regular' | 'accent';

export type StarPoint = {
  x: number;
  y: number;
  size: number;
  color: number;
  alpha: number;
  cross: boolean;
};

export type StarChunkConfig = {
  layer: StarLayerId;
  seed: number;
  width: number;
  height: number;
  count: number;
  sizeRange: { min: number; max: number };
  alphaRange: { min: number; max: number };
  colors: readonly number[];
  minimumDistance: number;
  crossChance: number;
};

export class StarChunkSeedSequence {
  public constructor(private nextSeed: number) {}

  public take(): number {
    const seed = this.nextSeed;
    this.nextSeed += 1;
    return seed;
  }
}

export const generateStarChunk = (config: StarChunkConfig): StarPoint[] => {
  const random = new SeededRandom(config.seed);
  const stars: StarPoint[] = [];
  const maximumAttempts = config.count * 20;
  let attempts = 0;
  while (stars.length < config.count && attempts < maximumAttempts) {
    attempts += 1;
    const x = Math.floor(random.next() * config.width);
    const y = Math.floor(random.next() * config.height);
    const isFarEnough = stars.every(
      (star) => Math.hypot(star.x - x, star.y - y) >= config.minimumDistance,
    );
    if (!isFarEnough) continue;
    const size = Math.floor(
      config.sizeRange.min + random.next() * (config.sizeRange.max - config.sizeRange.min + 1),
    );
    stars.push({
      x,
      y,
      size,
      color: config.colors[Math.floor(random.next() * config.colors.length)] ?? 0xf6f3d4,
      alpha:
        config.alphaRange.min + random.next() * (config.alphaRange.max - config.alphaRange.min),
      cross: random.next() < config.crossChance,
    });
  }
  return stars;
};
